import { apiRequest } from "@services/apiClient";
import startPointPromoCodesEndpoints from "@services/startPoints/startPointPromoCodesEndpoints";

function normalizePromoCodesFromBody(body) {
  if (Array.isArray(body?.promoCodes)) return body.promoCodes;
  if (Array.isArray(body?.items)) return body.items;
  if (Array.isArray(body)) return body;
  if (body?.promoCode && typeof body.promoCode === "object") return [body.promoCode];
  return [];
}

function buildPromoCodePayload(startPointId, promoCodePayload) {
  return {
    id: String(startPointId || ""),
    promo_code: {
      id: String(promoCodePayload?.id || ""),
      code: String(promoCodePayload?.code || ""),
      name: String(promoCodePayload?.name || ""),
      is_active: Boolean(promoCodePayload?.isActive),
      percentage: Number(promoCodePayload?.percentage || 0),
      max_uses:
        promoCodePayload?.maxUses === "" ||
        promoCodePayload?.maxUses === null ||
        promoCodePayload?.maxUses === undefined
          ? null
          : Number(promoCodePayload.maxUses),
      apple_product_id: String(promoCodePayload?.appleProductId || ""),
      google_product_id: String(promoCodePayload?.googleProductId || ""),
    },
  };
}

export async function listStartPointPromoCodesRequest(startPointId) {
  const response = await apiRequest(
    startPointPromoCodesEndpoints.byStartPointQuery(startPointId),
  );
  return {
    ...response,
    body: normalizePromoCodesFromBody(response?.body),
  };
}

function mapPromoCodeMutationResponse(response) {
  const normalizedBody = normalizePromoCodesFromBody(response?.body);
  return {
    ...response,
    body: normalizedBody,
  };
}

export async function createStartPointPromoCodeRequest(startPointId, payload) {
  const response = await apiRequest(startPointPromoCodesEndpoints.base, {
    method: "POST",
    body: buildPromoCodePayload(startPointId, payload),
  });
  return mapPromoCodeMutationResponse(response);
}

export async function updateStartPointPromoCodeRequest(startPointId, payload) {
  const response = await apiRequest(startPointPromoCodesEndpoints.base, {
    method: "PUT",
    body: buildPromoCodePayload(startPointId, payload),
  });
  return mapPromoCodeMutationResponse(response);
}

export async function saveStartPointPromoCodeRequest(startPointId, payload) {
  if (payload?.id) {
    return updateStartPointPromoCodeRequest(startPointId, payload);
  }

  return createStartPointPromoCodeRequest(startPointId, payload);
}

export async function deleteStartPointPromoCodeRequest(startPointId, promoCodeId) {
  void startPointId;
  return apiRequest(startPointPromoCodesEndpoints.byId(promoCodeId), {
    method: "DELETE",
  });
}
